// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-THLRO0","select":"select-w0uu19"};